export const billOptions = [
  'All Bills',
  'Bipartisan Safer Communities Act',
  'Consumer Product Safety Commission',
  'Coronavirus',
  'Corporation for National and Community Service',
  'Denali Commission',
  'Department of Agriculture',
  'Department of Commerce',
  'Department of Defense',
  'Department of Education',
  'Department of Energy',
  'Department of Health and Human Services',
  'Department of Homeland Security',
  'Department of Housing and Urban Development',
  'Department of Justice',
  'Department of Labor',
  'Department of the Interior',
  'Department of the Treasury',
  'Department of Transportation',
  'Department of Veterans Affairs',
  'Environmental Protection Agency',
  'Inflation Reduction Act',
  'Infrastructure Investment and Jobs Act',
  'Library of Congress',
  'National Aeronautics & Space Administration',
  'National Archives & Records Administration',
  'National Council on Disability',
  'National Foundation on the Arts and the Humanities',
  'National Science Foundation',
  'Nuclear Regulatory Commission',
  'Office of National Drug Control Policy',
  'Small Business Administration',
  'Social Security Administration',
];

// Mapping of available avatar background colors to foreground text colors
export const avatarColors = {
  '#44337A': '#FFF',
  '#086F83': '#FFF',
  '#234E52': '#FFF',
  '#702459': '#FFF',
  '#602314': '#FFF',
  '#BA8C03': '#000',
  '#6610F2': '#FFF',
  '#0DCAF0': '#000',
  '#198754': '#FFF',
  '#D63384': '#FFF',
  '#FD7E14': '#000',
  '#FFC107': '#000',
  '#B794F4': '#000',
  '#76E4F7': '#000',
  '#20C997': '#000',
  '#F687B3': '#000',
  '#F4B46D': '#000',
  '#FCD663': '#000',
};

export const defaultCloseDateThresholds = {
  warning: 30,
  danger: 15,
};
